export const Languages = {
  cs: 'Čeština',
  en: 'English',
  sk: 'Slovenčina',
};
